import Box from '@/common/components/Box';
import ResumeItem from '@/common/components/ResumeItem';
import { formatDateTime } from '@/common/utils/formatters';
import EstablishmentChoiceEntryProposalDiagnostic from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry/Proposal/Diagnostic';
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type';
import { MaintenanceForwardingEstablishmentChoiceEntryProposalData, MaintenanceForwardingEstablishmentChoiceEntryProposalStatus } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type';
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext';

interface EstablishmentChoiceEntryProposalProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData
  showProposalDiagnostic?: boolean
}

const EstablishmentChoiceEntryProposal = ({
  proposal,
  showProposalDiagnostic,
}: EstablishmentChoiceEntryProposalProps) => {
  const { directiveEntryKlass } = useForwardingTabContext();

  if (proposal.status === MaintenanceForwardingEstablishmentChoiceEntryProposalStatus.AwaitingEstablishmentResponse) {
    return null;
  }

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex flex-col gap-3">
        <div>
          <p className="font-semibold">Proposta</p>
        </div>

        <div className="flex gap-3">
          {proposal?.process_started_at && (
            <ResumeItem
              label="Data de envio"
              value={formatDateTime(new Date(proposal?.process_started_at))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {proposal?.establishment_accepted_by?.full_name && (
            <ResumeItem
              label="Usuário responsável pelo envio"
              value={proposal.establishment_accepted_by.full_name}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>

        {(proposal?.proposal_content?.start_at || proposal?.proposal_content?.deadline_to_complete_in_days != null) && (
          <div className="flex gap-3">
            {proposal?.proposal_content?.start_at && (
              <ResumeItem
                label="Data e hora sugerida"
                value={formatDateTime(new Date(proposal?.proposal_content?.start_at))}
                className="text-xs"
                valueClassName="font-bold text-sm"
              />
            )}

            {proposal?.proposal_content?.deadline_to_complete_in_days != null && (
              <ResumeItem
                label={
                  ({
                    [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: 'Prazo para envio do diagnostico e orçamento pós-check-in',
                    [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: 'Prazo para execução pós-check-in',
                  } as Partial<Record<MaintenanceForwardingsDirectiveEntryKlass, string>>)[directiveEntryKlass]
                  || 'Prazo para envio pós-check-in'
                }
                value={`${proposal?.proposal_content?.deadline_to_complete_in_days} Dias`}
                className="text-xs"
                valueClassName="font-bold text-sm"
              />
            )}
          </div>
        )}
      </div>

      {showProposalDiagnostic && (
        <div className="-mx-4 -mb-4">
          <EstablishmentChoiceEntryProposalDiagnostic />
        </div>
      )}
    </Box>
  )
}

export default EstablishmentChoiceEntryProposal
